import React from 'react';
import { useTranslation } from 'react-i18next';

type SettingsCellProps = {
  value: boolean;
};

export const YesNoCell = ({ value }: SettingsCellProps) => {
  const { t } = useTranslation('common');
  if (value) {
    return <>{t('table.yes')}</>;
  }
  return <> {t('table.no')}</>;
};
